import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciasService } from '../denuncias/denuncias.service';
import { Entrevista } from '../entrevista/entrevista';
import { EntrevistaService } from '../entrevista/entrevista.service';

import { Contrato } from '../contrato/contrato';
import { ContratoService } from '../contrato/contrato.service';

import { Local } from '../local/local';
import { LocalService } from '../local/local.service';

import { URL_API } from './../constante';

@Component({
  selector: 'app-atualizar-entrevista',
  templateUrl: './atualizar-entrevista.component.html',
  styleUrls: ['./atualizar-entrevista.component.css'],
  providers: [ ContratoService, LocalService, DenunciasService, EntrevistaService ]
})
export class AtualizarEntrevistaComponent implements OnInit {
  public denuncia: Denuncia;
  public entrevista: Entrevista;

  opFilhos: boolean;
  fileUrl: string;

  opcaoAluno: boolean;
  opcaoTecAdm: boolean;
  opcaoDocTecSup: boolean;

  outroContrato: boolean;
  outroSexo: boolean;
  opSexo: boolean;
  outroLocalTrabalhoEstudo: boolean;
  opTestemunha: boolean;

  itensLocalTrabalho = [];
  itensTipoContrato = [];

  contratos: Contrato[];

  locais: Local[];

  denuncia_id: number;

  // mascara para data de nascimento
  public maskDataNasc = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/]

  constructor(private denunciaService: DenunciasService,
    private entrevistaService: EntrevistaService,
    private contratoService: ContratoService,
    private localService: LocalService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location
  ) {
    this.denuncia = new Denuncia();
    this.entrevista = new Entrevista();
  }

  getContratos(): void {
    this.contratoService.getContratos()
    .then(contrato => this.contratos = contrato);
  }

  getLocais(): void {
    this.localService.getLocais()
    .then(local => this.locais = local);
  }

  subOpcaoFilhos(bool: boolean) {
    this.opFilhos = bool;
    if (!bool) {
      this.entrevista.qtdFilhos = 0;
      this.entrevista.idadeFilhos = '';
    }

  }

  subOpcaoAluno(bool: boolean) {
    this.opcaoAluno = bool;
    if (!bool) {
      this.entrevista.curso = '';
      this.entrevista.periodo = '';
      this.entrevista.nomeAtividade = '';
    }

  }

  subOpcaoTecAdm(bool: boolean) {
    this.opcaoTecAdm = bool;
    if (!bool) {
      this.entrevista.escolaridade_id = 0;
    }

  }

  subOpcaoDocTecSup(bool: boolean) {
    this.opcaoDocTecSup = bool;
    if (!bool) {
      this.entrevista.atuaGraduacao = '';
      this.entrevista.atuaPosLato = '';
      this.entrevista.atuaPosStricto = '';
      this.entrevista.atuaExtensao = '';
      this.entrevista.atuaPesquisa = '';
    }
  }

  subOutroContrato() {
    if (this.outroContrato) {
      this.entrevista.outroContratoTrabalho = '';
    }
    this.outroContrato = !this.outroContrato;
  }

  subOutroSexo() {
    this.outroSexo = true;
  }

  subOpcaoSexo() {
    this.outroSexo = false;
    this.entrevista.outroSexo = '';
  }

  subOutroLocal() {
    if (this.outroLocalTrabalhoEstudo) { // checkbox checked
      this.entrevista.outroLocalTrabalhoEstudo = '';
    }
    this.outroLocalTrabalhoEstudo = !this.outroLocalTrabalhoEstudo;
  }

  selTestemunha() { // selecionou testemunha
    this.opTestemunha = true;
    if (this.opcaoAluno) {
      this.entrevista.curso = '';
      this.entrevista.periodo = '';
      this.entrevista.nomeAtividade = '';
    }

    if (this.opcaoTecAdm) {
      this.entrevista.escolaridade_id = 0;
    }

    if (this.opcaoDocTecSup) {
      this.entrevista.atuaGraduacao = '';
      this.entrevista.atuaPosLato = '';
      this.entrevista.atuaPosStricto = '';
      this.entrevista.atuaExtensao = '';
      this.entrevista.atuaPesquisa = '';
    }

  }

  selopIdentif() { // selecionou alvo ou denunciado
    this.opTestemunha = false;
  }

  selLocalTrabalho(value,event){
    if (event.target.checked) {
      //console.log('emp ' + value);
      this.itensLocalTrabalho.push(value);
    }
    else if (!event.target.checked) {
      //console.log('desemp ' + value);
      let indexx = this.itensLocalTrabalho.indexOf(value);
      this.itensLocalTrabalho.splice(indexx,1);
    }
    //console.log("CHECKBOX LOCAL ");
    //console.log(this.itensLocalTrabalho);
  }

  selTipoContrato(value,event){
    if (event.target.checked) {
      this.itensTipoContrato.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensTipoContrato.indexOf(value);
      this.itensTipoContrato.splice(indexx,1);
    }
    //console.log("CHECKBOX CONTRATO TRABALHO ");
    //console.log(this.itensTipoContrato);
  }

  getDenuncia(): void{
    this.route.params.forEach((params: Params) => {
     let id = params['id']; // id da denuncia

    this.denuncia_id = id;

    if (id !== undefined) {
      this.denunciaService.getDenuncia(id)
         .then((denuncia) => this.denuncia = denuncia);
    }

   });

  }

  getEntrevista(): void{
    this.route.params.forEach((params: Params) => {
     let id = params['id'];

     if (id !== undefined) {
       this.entrevistaService.getEntrevista(id)
         .then((entrevista) => {
           //console.log(JSON.stringify(entrevista));
           this.itensLocalTrabalho = entrevista.locais;
           this.itensTipoContrato = entrevista.contratos;
           null !== entrevista.outroSexo ? this.outroSexo = true : this.outroSexo = false;
           null !== entrevista.outroContratoTrabalho ? this.outroContrato = true : this.outroContrato = false;
           null !== entrevista.outroLocalTrabalhoEstudo ? this.outroLocalTrabalhoEstudo = true : this.outroLocalTrabalhoEstudo = false;
           entrevista.filhos ? this.opFilhos = true : this.opFilhos = false;
           entrevista.identif == "testemunha" ? this.opTestemunha = true : this.opTestemunha = false;
           entrevista.alunoFM ? this.opcaoAluno = true : this.opcaoAluno = false;
           entrevista.tecAdmTercOutro ? this.opcaoTecAdm = true : this.opcaoTecAdm = false;
           entrevista.docenteTecSup ? this.opcaoDocTecSup = true : this.opcaoDocTecSup = false;
           this.entrevista = entrevista
         });
     }

   });

  }


  ngOnInit() {
    this.opFilhos = false;
    this.outroSexo = false;
    this.opSexo = false;
    this.outroLocalTrabalhoEstudo = false;
    this.outroContrato = false;
    this.opTestemunha = false;

    this.fileUrl = URL_API + '/download/';

    this.getContratos();

    this.getLocais();

    this.getEntrevista();

  }

  salvar(): void {
    // setando os ids dos locais de trabalho escolhidos
    this.entrevista.itensLocalTrabalhoFinal = this.itensLocalTrabalho;

    // setando os ids dos contratos de trabalho escolhidos
    this.entrevista.itensTipoContratoFinal = this.itensTipoContrato;

      if (this.entrevista.id) {
        this.entrevistaService.salvarEntrevista(this.entrevista)
            .then(() => this.goBack())
            .catch(erro => window.scrollTo(0,0));
      }

  }

  goBack(): void {
     this.router.navigate(['/denuncias']);
  }

}



// WEBPACK FOOTER //
// ./src/app/atualizar-entrevista/atualizar-entrevista.component.ts